import { API_URL } from '../../constants';

// Llamadas del expediente Mobile. Lecturas (M.2B): GET a los mismos endpoints
// y con la misma forma de respuesta que consume el expediente Desktop
// (Empleados.jsx / Capacitaciones.jsx). Única escritura (M.2B.2): anexar
// documento, más abajo.

async function leer(path, id) {
  const res = await fetch(API_URL + `?path=${path}&id=${encodeURIComponent(String(id))}`);
  const data = await res.json();
  if (!data || !data.success) throw new Error((data && data.error) || 'Respuesta sin éxito');
  return data;
}

// api/empleado/detalle -> obtenerEmpleadoDetalle(id)
export async function obtenerDetalleEmpleado(id) {
  return (await leer('api/empleado/detalle', id)).empleado || null;
}

// api/empleado/capacitaciones -> obtenerCapacitacionesEmpleado(id)
export async function obtenerCapacitacionesEmpleado(id) {
  return (await leer('api/empleado/capacitaciones', id)).capacitaciones || [];
}

// api/empleado/anexos -> listarAnexos(id) (Drive: carpeta Documentos_Firmados)
export async function obtenerAnexosEmpleado(id) {
  return (await leer('api/empleado/anexos', id)).anexos || [];
}

// ─── Única escritura del expediente Mobile (M.2B.2) ─────────────────────────
// POST api/empleado/anexar -> anexarDocumento(datos, usuario): mismo endpoint,
// método y payload que ExpDocumentacion de Desktop. Sólo se considera éxito
// con `success: true`. El backend no es idempotente: NUNCA se reintenta aquí.
export const ESPERA_MAXIMA_ANEXAR_MS = 90000;

export async function anexarDocumentoEmpleado({ id_empleado, base64, nombre_archivo }, esperaMs = ESPERA_MAXIMA_ANEXAR_MS) {
  const control = typeof AbortController !== 'undefined' ? new AbortController() : null;
  const limite = control ? setTimeout(() => control.abort(), esperaMs) : null;
  try {
    const res = await fetch(API_URL + '?path=api/empleado/anexar', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id_empleado, base64, nombre_archivo }),
      signal: control ? control.signal : undefined
    });
    const data = await res.json();
    if (!data || data.success !== true) throw new Error((data && data.error) || 'Respuesta sin confirmación');
    return data;
  } finally {
    if (limite) clearTimeout(limite);
  }
}

// ─── Registro de capacitación (M.2B.3) ──────────────────────────────────────
// Catálogo: api/capacitaciones/listar -> listarCapacitaciones() (misma fuente
// que el modal Desktop "Subir Registro Escaneado").
export async function obtenerCatalogoCapacitaciones() {
  const res = await fetch(API_URL + '?path=api/capacitaciones/listar');
  const data = await res.json();
  if (!data || !data.success) throw new Error((data && data.error) || 'Respuesta sin éxito');
  return data.capacitaciones || [];
}

// POST api/capacitaciones/subir-registro -> subirRegistroCapacitacion(datos):
// mismo endpoint y payload que el modal Desktop ({ id_capacitacion, base64,
// nombre_archivo, fecha, empleados }). Desde el expediente Mobile `empleados`
// es SIEMPRE [id del empleado abierto]. Sólo `success: true` es éxito; el
// backend no es idempotente: NUNCA se reintenta aquí.
export async function subirRegistroCapacitacionEmpleado({ id_capacitacion, base64, nombre_archivo, fecha, id_empleado }, esperaMs = ESPERA_MAXIMA_ANEXAR_MS) {
  const control = typeof AbortController !== 'undefined' ? new AbortController() : null;
  const limite = control ? setTimeout(() => control.abort(), esperaMs) : null;
  try {
    const res = await fetch(API_URL + '?path=api/capacitaciones/subir-registro', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id_capacitacion, base64, nombre_archivo, fecha, empleados: [String(id_empleado)] }),
      signal: control ? control.signal : undefined
    });
    const data = await res.json();
    if (!data || data.success !== true) throw new Error((data && data.error) || 'Respuesta sin confirmación');
    return data;
  } finally {
    if (limite) clearTimeout(limite);
  }
}

// El id puede venir como texto con ceros ("00416") o como número (416)
// según la celda: se consideran el mismo empleado.
export function mismoIdEmpleado(a, b) {
  const x = String(a == null ? '' : a).trim();
  const y = String(b == null ? '' : b).trim();
  if (!x || !y) return false;
  if (x === y) return true;
  return /^\d+$/.test(x) && /^\d+$/.test(y) && x.replace(/^0+(?=\d)/, '') === y.replace(/^0+(?=\d)/, '');
}
